import { UtmParams } from "./types"

export function extractUtmParams(): UtmParams {
    const url = new URL(window.location.href)
    const params: UtmParams = {}

    const utmKeys: Array<keyof UtmParams> = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
        "gclid",
    ]

    utmKeys.forEach((key) => {
        const value = url.searchParams.get(key)
        if (value) {
            params[key] = value
        }
    })

    return params
}
